
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document-declined",
      function () {
        return require("private-next-pages/document-declined.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document-declined"])
      });
    }
  